// Título, descrição e imagem de partilha de cada página pública. Fonte única do pré-render (entry-server → prerender.ts)
// e do browser (AppLayout), para as duas concordarem. As páginas do Mundo têm as suas próprias.
import type { Lang } from "@ecliptica/i18n";
import { characterImage, nodeOf, resolveWorld, WORLD_SUMMARY } from "@ecliptica/game-ui/world";
import { isCardsPage, legalPageOf, worldSegments } from "./lang";

type Translate = (key: string, options?: Record<string, unknown>) => string;
export type PageMeta = { title: string; description: string; image: string | null };

export function pageMeta(pathname: string, lang: Lang, t: Translate): PageMeta {
  const segments = worldSegments(pathname);
  const sel = segments ? resolveWorld(segments) : null;
  if (sel) {
    const node = nodeOf(sel);
    if (!node) return { title: t("world.page.metaTitle"), description: WORLD_SUMMARY[lang], image: "/bg/lore.webp" };
    return {
      title: t("world.page.metaSuffix", { name: node.name[lang] }),
      description: node.summary[lang],
      image: "image" in node && node.image ? characterImage(node.id) : "/bg/lore.webp",
    };
  }
  if (isCardsPage(pathname)) return { title: t("cards.page.metaTitle"), description: t("cards.page.metaDescription"), image: null };
  const legal = legalPageOf(pathname);
  if (legal) return { title: t(`legal.${legal}.metaTitle`), description: t(`legal.${legal}.metaDescription`), image: null };
  return { title: t("meta.title"), description: t("meta.description"), image: null };
}
